import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

export type MyNumberState = {
  myNumber: string
  id: string
  previousNumber?: string
  country: string[]
  providerId: string
}
const initialState: MyNumberState = {
  myNumber: "",
  id: "",
  previousNumber: "",
  providerId: "",
  country: []
}

export const sliceKey = "myNumber"

export const myNumberSlice = createSlice({
  name: sliceKey,
  initialState,
  reducers: {
    /**
     * Set the current myNumber and update the previousNumber.
     * @param {MyNumberState} payload The new myNumber to set.
     */
    setMyNumber: (
      state: MyNumberState,
      action: PayloadAction<MyNumberState>
    ) => {
      state.previousNumber = state.myNumber
      state.myNumber = action.payload.myNumber
      state.id = action.payload.id
      state.country = action.payload.country
      state.providerId = action.payload.providerId
    }
  }
})

export const { setMyNumber } = myNumberSlice.actions

export default myNumberSlice.reducer
